import { environment } from '@lla-platform/core/core-util'

export const EVENTS_CALENDAR_API_URL = {
  users: `${environment.apiUrl}/calendarevents/users`,
  list: `${environment.apiUrl}/calendarevents/list`,
  tasksList: `${environment.apiUrl}/calendarevents/tasks/list`,
  taskCreate: `${environment.apiUrl}/calendarevents/tasks`,
  taskUpdate: (taskId: string) => `${environment.apiUrl}/calendarevents/tasks/${taskId}`,
  create: `${environment.apiUrl}/calendarevents`,
  update: (eventId: string) => `${environment.apiUrl}/calendarevents/${eventId}`,
  delete: (eventId: string) => `${environment.apiUrl}/calendarevents/${eventId}`,
  taskStatus: (taskId: string) => `${environment.apiUrl}/calendarevents/tasks/${taskId}/status`,
  taskDelete: (taskId: string) => `${environment.apiUrl}/calendarevents/tasks/${taskId}`,
  inspectionForm: (eventId: string, inspectionType: string) =>
    `${environment.apiUrl}/calendarevents/${eventId}/inspections/${inspectionType}/form`,
  byForm: (formId: string) => `${environment.apiUrl}/calendarevents/by-form/${formId}`
}
